import React, {useEffect, useRef, useState} from 'react';

const CustomSlide1 = ({children, className = ''}) => {
    const sectionRef = useRef(null);
    const [translateY, setTranslateY] = useState(0);

    useEffect(() => {
        let frameId = null;

        const updatePosition = () => {
            frameId = null;

            const section = sectionRef.current;
            if (!section) {
                return;
            }

            const rect = section.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

            if (viewportHeight <= 0) {
                return;
            }

            const progress = Math.min(1, Math.max(0, 1 - rect.top / (viewportHeight * 0.9)));
            const nextTranslateY = Math.round(-progress * 90);

            setTranslateY(nextTranslateY);
        };

        const handleScroll = () => {
            if (frameId === null) {
                frameId = window.requestAnimationFrame(updatePosition);
            }
        };

        updatePosition();
        window.addEventListener('scroll', handleScroll, {passive: true});
        window.addEventListener('resize', handleScroll);

        return () => {
            if (frameId !== null) {
                window.cancelAnimationFrame(frameId);
            }
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);

    return (
        <section className="" aria-label="">
        <div
            ref={sectionRef}
            className={`ps-custom-slide1 ${className}`.trim()}
            style={{
                position: 'relative',
                width: '100%',
                overflow: 'hidden',
            }}
        >
            <img
                src="/assets/img/custom_comp1.png"
                alt=""
                aria-hidden="true"
                style={{
                    position: 'relative',
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    // transform: `translateY(${translateY}px)`,
                    willChange: 'transform',
                }}
            />

            {children ? (
                <div
                    style={{
                        position: 'relative',
                        zIndex: 1,
                        width: '100%',
                        height: '100%',
                    }}
                >
                    {children}
                </div>
            ) : null}
        </div>
        </section>
    );
};

export default CustomSlide1;
